import 'css-chunk:../authentication/frontend/components/page/index.module.scss';export default {
  "earphones": "_earphones_1v2jx_2",
  "form": "_form_1v2jx_7"
};